import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";


export default function SelectRole(props: {
  handleSelection: any;
  label: string;
  rolesList: Array<string> ;
  defaultValue?: string;
}) {
  

  return (
    <Box marginTop={2} sx={{ minWidth: 180 }}>
      <FormControl fullWidth>
        <InputLabel style={{ backgroundColor: "white" }}>
          {props.label}
        </InputLabel>
        {props.rolesList &&
        <Select
          label={props.label}
          onChange={props.handleSelection}
          defaultValue={props.defaultValue ? props.defaultValue : ""}
        >
          {props.rolesList.map((role, item) => (
            <MenuItem key={item} value={role}>{(role).toLowerCase().charAt(0).toUpperCase() + (role.toLowerCase().slice(1))}
            </MenuItem>
          ))}
        </Select>
}
      </FormControl>
    </Box>
  );
}